import {MaxMortgage} from '@cmp/modules/editor/max-mortgage/max-mortgage.model';
import {ofType, unionize, UnionOf} from 'unionize';

export const NonPersistentActions = unionize({
  SetMaxMortgage: ofType<MaxMortgage>(),
}, {tag: 'type', value: 'payload'});

export type NonPersistentAction = UnionOf<typeof NonPersistentActions>;
